import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteNotificationRulesMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ notificationRuleIds }: { notificationRuleIds: string[] }) => {
      return toast.promise(
        client.delete(`/notifications/rules`, {
          data: { notificationRuleIds },
        }),
        {
          loading: 'Deleting notification rules...',
          success: 'Successfully deleted the notification rules.',
          error: (_: unknown) =>
            `Uh oh, there was an error with deleting the notification rules.`,
        }
      );
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', 'rules'] });
    },
  });
};
